/* i18n-ignore: interne adminpagina, alleen NL */
import { createFileRoute, redirect } from "@tanstack/react-router";

/** Het oude fotoscherm bestaat niet meer; oude bladwijzers gaan naar het nieuwe scherm. */
export const Route = createFileRoute("/_authenticated/admin/fotos")({
  staticData: { sitemap: false },
  beforeLoad: () => {
    throw redirect({ to: "/admin/foto-ordenen" });
  },
});
